module.exports = __webpack_public_path__ + "images/iphone-037a1d.png";